<template>
  <span>
    <section
      v-if="intervenant.intervenantContacts"
      :class="{'is-flex is-justify-content-space-between': isEdit}">
      <span v-if="!isEdit"> {{ $t('detail.client.contact') }} </span>
      <span>
        <span v-if="intervenant.intervenantContacts.length === 0">
          {{$t('ajoutDevis.table.editionContacts.aucunContact')}}
        </span>
        <span v-else v-html="getAllContacts(intervenant.intervenantContacts)"></span>
      </span>
      <a
        v-if="isEdit"
        class="mgl-2"
        @click="popUpEditContacts =true; intervenantToEdit=intervenant">
          <b-icon
            type="is-success"
            :icon="intervenant.intervenantContacts.length === 0 ?
            'plus-box-outline' : 'pencil-box-outline'"
            size="small"/>
      </a>
    </section>
    <b-modal v-if="isEdit" v-model="popUpEditContacts">
      <popUpEditContacts :intervenant="intervenant" />
    </b-modal>
  </span>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import popUpEditContacts from '@/components/devisCommandes/editionDevisCommande/p_editContacts';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      popUpEditContacts: false,
    };
  },
  props: {
    intervenant: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    popUpEditContacts,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typeContact() {
      return this.parametre(PARAMETRES_KEYS.typeContact);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getTypeContact(typeContactId) {
      const typeContact = this.typeContact.find((el) => typeContactId === el.id);
      if (typeContact) {
        return typeContact.libelle;
      }
      return '';
    },
    getAllContacts(interContacts) {
      return interContacts.map(ic => {
        return `${ic.contact?.nom} ${ic.contact?.prenom} ${ic.contactTypes.length > 0 ? `(${ic.contactTypes.map(ictype => this.getTypeContact(ictype.typeContactId)).join(', ')})` : ''}`;
      }).join(`${this.isEdit ? '<br />' : ' - '}`);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeContact]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
